"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boosters = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
exports.boosters = (0, basic_1.applyBase)({
    boosterWrap: {
        display: 'flex',
        width: '100%',
        padding: [`0 ${basic_1.basic.space[2]}`, 0],
        marginBottom: basic_1.basic.space[2],
        backgroundColor: basic_1.basic.colors.bgDarkBlueSecond,
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        borderRadius: basic_1.basic.radii.default,
        color: 'white',
        '.booster-text': Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.M), { pl: [2, '30px'], pr: 2, py: [2, 3], variant: 'text.richText', 'p:last-child': {
                mb: 0,
            }, a: {
                color: 'inherit',
                textDecoration: 'underline',
            } }),
    },
});
//# sourceMappingURL=boosters.js.map